import React from 'react'
import { Link } from 'react-router-dom'
import imagePersonBlue from '../../../images/personblue.png'
import InputShadowTwo from '../../elements/InputShadowTwo'

const ViewClients = ({ values, handleChange, clients, refresh }) => {
    return ( 
        <div className='mt-3'>

            {/* AFFICHAGE BARRE DE RECHERCHE */}
            <InputShadowTwo name='name' value={values.name} onChange={handleChange} placeholder='Client' image={imagePersonBlue} onClick={refresh} />

            {/* AFFICHAGES DE LA LISTE DES CLIENTS */}
            <div className='mt-3'>
                {clients.filter(c => c.name.includes(values.name.toUpperCase().trim())).sort((a,b) => a.name > b.name ? 1 : -1).map(c => (
                    <Link 
                        to='/client' 
                        className='text-decoration-none' 
                        style={{ color:'black' }} 
                        state={{ 
                            uidClient:c.uid, 
                            nameClient:c.name, 
                            surnameClient:c.surname,
                            emailClient:c.email,
                        }}
                    >
                        <div key={c.id} className='row mt-1 border-0 shadow p-1'>
                            <div className='card-body'>
                                <div style={{ cursor:'pointer' }}>{c.name}  {c.surname}</div>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>

        </div> 
    )
}

export default ViewClients






